import { render, staticRenderFns } from "./chooseOne.vue?vue&type=template&id=3d5d7de8&scoped=true&"
import script from "./chooseOne.vue?vue&type=script&lang=js&"
export * from "./chooseOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5d7de8",
  null
  
)

export default component.exports